import React, {useState, useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useTitle} from 'react-use';

import {withStyles} from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {getRandomString} from 'components/constants';

import logo from 'img/login-logo.svg';
import SubLoading from 'components/loading';

import {mostrarAlerta} from 'actions/alertaActions';
import {useSelector, useDispatch} from 'react-redux';
import {iniciarSesion} from 'actions/usuarioActions';

const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#009ddd',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#009ddd',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({classes, ...props}) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function Login({iesAuth}) {
    let history = useHistory();
    let location = useLocation();

    const dispatch = useDispatch();

    useTitle('Colegio Universitario IES - Acceso');

    // const [loading, setLoading] = useState(true);
    const loading = useSelector((state) => state.usuario.loading);
    const usuario = useSelector((state) => state.usuario.usuario);

    const namesForm = {
        dni: getRandomString(15),
        pass: getRandomString(15),
    };
    const reverseNamesForm = {};
    Object.keys(namesForm).forEach((key) => (reverseNamesForm[namesForm[key]] = key));

    const [form, setForm] = useState({dni: '', pass: '', guardasesion: false});

    const {from} = location.state || {from: {pathname: '/'}};

    const isTid = from.pathname.indexOf('/tid') > -1;

    let login = (e) => {
        e.preventDefault();

        const dni = form.dni.trim().replace(/\.+/g, '');
        const pass = form.pass.trim();

        if (dni.length < 5) {
            dispatch(mostrarAlerta('Escriba su dni', 'Login'));
            return;
        }
        if (pass.length < 3) {
            dispatch(mostrarAlerta('Escriba una contraseña válida', 'Login'));
            return;
        }

        const data = {dni, pass, guardasesion: form.guardasesion};

        localStorage.setItem('perma', form.guardasesion);

        dispatch(iniciarSesion(data));
    };

    const handleChange = (e) => {
        if(e.target.name === 'guadasesion'){
            setForm({...form, guardasesion: e.target.checked});
        }else{
            const nameField = reverseNamesForm[e.target.name];
            setForm({...form, [nameField]: e.target.value});
        }
    };

    useEffect(() => {
        if (usuario && Object.keys(usuario).length > 1) {
            iesAuth.authenticate(() => {
                history.replace(!isTid ? '/' : from);
            });
        }
    }, [usuario, history, from, iesAuth, isTid]);

    return (
        <div className="contenedor login">
            <br />
            <img src={logo} alt="" />
            <br />
            <br />
            <br />

            <form onSubmit={login} className="login">
                <input
                    type="text"
                    pattern="[0-9]*"
                    onChange={handleChange}
                    name={namesForm.dni}
                    placeholder=" DNI "
                    tabIndex="1"
                    autoFocus
                    className="p0"
                />

                <input
                    type="password"
                    onChange={handleChange}
                    name={namesForm.pass}
                    placeholder=" Contraseña "
                    tabIndex="2"
                    className="p0"
                />

                <FormControlLabel
                    className="ajustes"
                    control={<IOSSwitch checked={form.guardasesion} onChange={handleChange} name="guadasesion" />}
                    label="Guardar mi sesión en este dispositivo"
                />

                <br />
                <br />

                <button type="submit" tabIndex="3" disabled={loading}>
                    {loading && <SubLoading />} LOGIN
                </button>
            </form>
        </div>
    );
}
